import keyBy from 'lodash/keyBy';
import uniq from 'lodash/uniq';
import { fromJS, Map } from 'immutable';
import { ACTIVE_QUIZ_SESSION_CHANGE, ADD_QUIZ_SESSIONS, ADD_SESSION_ITEMS } from '@instructure/quiz-common';
var updateQuizSessionSessionItemReferences = function updateQuizSessionSessionItemReferences(state, sessionItems) {
  var reducer = function reducer(tempState, sessionItem) {
    return tempState.updateIn([sessionItem.quizSessionId, 'sessionItems'], function (items) {
      return (items || fromJS([])).push(sessionItem.id);
    });
  };
  var uniqifySessionItems = function uniqifySessionItems(quizSession) {
    if (!(quizSession instanceof Map)) {
      return quizSession;
    }
    return quizSession.updateIn(['sessionItems'], function (items) {
      var jsItems = items ? items.toJS() : [];
      return fromJS(uniq(jsItems));
    });
  };
  return sessionItems.reduce(reducer, state).map(uniqifySessionItems);
};
var addQuizSessions = function addQuizSessions(state, quizSessions) {
  var keyedQuizSessions = keyBy(quizSessions, 'id');
  return state.mergeWith(
  // to avoid replacing Lists with null (sessionItems)
  function (oldValue, newValue) {
    return oldValue.merge ? oldValue.merge(newValue) : newValue;
  }, fromJS(keyedQuizSessions));
};
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_QUIZ_SESSIONS:
      return addQuizSessions(state, action.payload);
    case ADD_SESSION_ITEMS:
      return updateQuizSessionSessionItemReferences(state, action.payload);
    case ACTIVE_QUIZ_SESSION_CHANGE:
      return state.set('activeQuizSessionId', action.payload);
    default:
      return state;
  }
});